<template>
    <v-app-bar
        app
        color="white"
        height="114"
        flat
    >
      <div class="header-time-container">
        <div>
          <span class="header-time">{{ realtime }}</span>
          <span class="header-date">{{ todayDate }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <div class="mt-2 d-flex align-items-center justify-content-center false-icon-big">
          <img class="false-icon-big-image" :src="selectedLogo" height="68" width="68" alt="">
          <h1 class="ma-2 text-nowrap hidden-md-and-down"><router-link to="/">{{ shortTitle }}</router-link></h1>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <motivation />
      <menu-dropdown />
    </v-app-bar>
</template>
<script>
import logo2atm from '../../assets/logo-2atm.png'
import logoJsShina from '../../assets/js-shina.webp'
import logoPitpos from '../../assets/pitpos.webp'

export default {
  name: "HeaderRow",
  components: {
    menuDropdown: () => import('../mainpage/MenuDropdown-new.vue'),
    motivation: () => import('../mainpage/Motivation.vue')
  },
  data() {
    return {
      shortTitle: process.env.VUE_APP_SHORT_TITLE,
      todayDate: '',
      realtime: '',
      logo2atm,
      logoJsShina,
      logoPitpos
    }
  },
  computed: {
    selectedLogo() {
      if (process.env.VUE_APP_LOGO_IMAGE === 'js-shina') {
        return this.logoJsShina
      }
      if (process.env.VUE_APP_LOGO_IMAGE === 'pitpos') {
        return this.logoPitpos
      }
      return this.logo2atm
    }
  },
  mounted () {
    this.todayDate = this.getTodayDate()
    this.getRealtime()
  },
  methods: {
    goHome() {
      this.$store.dispatch('goToCashHome')
    },
    getRealtime () {
      const today = new Date();
      let Hour = today.getHours();
      let Minutes = today.getMinutes();
      setTimeout(() => this.getRealtime(), 1000);
      if ( Hour <= 9) { Hour = '0' + Hour }
      if ( Minutes <= 9) { Minutes = '0' + Minutes }
      this.realtime = Hour + ':' + Minutes
    },
    getTodayDate () {
      const today = new Date();
      const Month = today.getMonth();
      const Day = today.getDate();
      let fMonth = ''
      // Преобразуем месяца
      switch (Month)
      {
        case 0: fMonth="января"; break;
        case 1: fMonth="февраля"; break;
        case 2: fMonth="марта"; break;
        case 3: fMonth="апреля"; break;
        case 4: fMonth="мая"; break;
        case 5: fMonth="июня"; break;
        case 6: fMonth="июля"; break;
        case 7: fMonth="августа"; break;
        case 8: fMonth="сентября"; break;
        case 9: fMonth="октября"; break;
        case 10: fMonth="ноября"; break;
        case 11: fMonth="декабря"; break;
      }
// Вывод
      return Day + ' ' + fMonth
    }
  },

}
</script>
<style scoped>
.header-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.header-icons-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-icons {
  justify-content: center;
  align-items: center;
  display: flex;
}
.header-time {
  width: 110px;
  height: 37px;
  font-family: "PFBeauSanspro-bold", sans-serif !important;
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.header-date {
  position: absolute;
  top: 69px;
  left: 47px;
  width: 110px;
  height: 16px;
  font-family: 'Istok Web', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.header-time-container {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
h1 a {
  color:#000000 !important;
  text-decoration:none;
}
</style>
